import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import './slides.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// import slide1 from '../../../../assets/slides/s1.jpg'
// import slide2 from '../../../../assets/slides/s2.png'
// import slide3 from '../../../../assets/slides/s3.jpg'
// import slide4 from '../../../../assets/slides/s4.png'
// import slide5 from '../../../../assets/slides/s3.2.mp4'
import slide6 from '../../../../assets/slides/s4.2.mp4'
import slide7 from '../../../../assets/slides/s5.2.mp4'
import hero2 from '../../../../assets/slides/s1.2.mp4'
import hero from '../../../../assets/slides/s2.2.mp4'

const Slides = () => {
    return  (
        <section className="w-full ">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 15000 }}
            loop={true}
            className="hero-swiper"
          >
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <video src={hero} autoPlay loop muted></video>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <video src={hero2} autoPlay loop muted></video>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <video src={slide5} autoPlay loop muted></video>
              </div>
            </SwiperSlide> */}
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <video src={slide6} autoPlay loop muted></video>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <video src={slide7} autoPlay loop muted></video>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <img src={slide1} alt="" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <img src={slide2} alt="" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <img src={slide3} alt="" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="h-full bg-cover bg-center" >
                <img src={slide4} alt="" />
              </div>
            </SwiperSlide> */}
            
          </Swiper>
        </section>
      );
}

export default Slides